import React, { useState } from 'react'
import cn from 'classnames'
import { IconButton } from '@components/ui-lib/button/icon-button'
import { Copy } from '@components/ui-lib/icons/social-share'
import { Text } from '@grammarly/design-system'
import styles from './social-share-button.module.scss'
import { useIsSectionThemeDark } from '@contexts/section-theme-context'

const COPY_STATES = {
  idle: 'Copy link',
  copied: 'Link copied!',
} as const

export interface ShareLinkButtonProps {
  link: string
}

export const ShareLinkButton: React.FC<ShareLinkButtonProps> = ({ link }) => {
  const [isCopied, setIsCopied] = useState(false)
  const isDarkThemeSection = useIsSectionThemeDark()

  const handleClick = () => {
    if (!navigator.clipboard) {
      console.error('Clipboard is not supported')
      return
    }
    navigator.clipboard.writeText(link)
    setIsCopied(true)
  }

  const handleTooltipHide = () => {
    setTimeout(() => {
      setIsCopied(false)
    }, 300)
  }

  return (
    <IconButton
      className={cn(styles.shareButton, {
        [styles.darkTheme]: isDarkThemeSection,
      })}
      onClick={handleClick}
      tooltip={{
        content: (
          <Text as="span" variant="text-xsmall">
            {isCopied ? COPY_STATES.copied : COPY_STATES.idle}
          </Text>
        ),
        lightTheme: isDarkThemeSection,
        onHide: handleTooltipHide,
      }}
      aria-label={COPY_STATES.idle}
    >
      <Copy />
    </IconButton>
  )
}
